import { WsMessage, WsMessageCategory } from '@numeo/types-core'
import { AgentActivityBaseMessage, AgentActivityActionTypes } from '@numeo/types-main-web-app'
import { AppDispatch } from 'store'
import { addRecentActivity } from '../../agentActivitiesSlice'

// Helper function to handle Agent Activity messages
export const handleAgentActivityMessages = (message: WsMessage, dispatch: AppDispatch) => {
    if (message.categoryType !== WsMessageCategory.AgentActivity) return

    try {
        const agentActivityMessage = message as AgentActivityBaseMessage
        const { action, activity } = agentActivityMessage.data

        if (action === AgentActivityActionTypes.ACTIVITY_CREATED && activity) {
            dispatch(
                addRecentActivity({
                    ...activity,
                    createdAt: new Date(activity.createdAt),
                })
            )
        }
    } catch (error) {
        console.error('Error handling agent activity message:', error)
    }
}
